import { Component, ViewModel, ObservableArray, View } from "binder";
import  { TimeSelectorView } from "./timeSelector-view"

export class TimeSelectorViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this._isUpdatingEnabled = true;
        this.hours = ObservableArray.create<TimePart>();
        this.minutes = ObservableArray.create<TimePart>();
        this.hours.update(...Array.from(new Array(24).keys()).map((x,i)=>{
            let r = new TimePart(this);
            r.no=i;
            return r;
        }));
        this.minutes.update(...Array.from(new Array(60).keys()).map((x,i)=>{
            let r = new TimePart(this);
            r.no=i;
            return r;
        }));
    }
    GetDefaultView(): View <ViewModel> {
        return new TimeSelectorView();
    }
    public getTypeId(): string {
        return "VM-D0954AFC-9429-4838-BC54-AD0DBF43C477"
    }

    public set hours(v: ObservableArray<TimePart>) { this._hours = v; } public get hours(): ObservableArray<TimePart> { return this._hours;} private _hours: ObservableArray<TimePart>;
    public set minutes(v: ObservableArray<TimePart>) { this._minutes = v; } public get minutes(): ObservableArray<TimePart> { return this._minutes;} private _minutes: ObservableArray<TimePart>;
    private _isUpdatingEnabled;
    
    public set selectedHour(v: TimePart) { 
        this._selectedHour = v; 
        this.updateSelectedTime();
    } public get selectedHour(): TimePart { return this._selectedHour;} private _selectedHour: TimePart;
    public set selectedMinute(v: TimePart) { 
        this._selectedMinute = v; 
        this.updateSelectedTime();
    } public get selectedMinute(): TimePart { return this._selectedMinute;} private _selectedMinute: TimePart;
    
    private updateSelectedTime(){
        if(this._isUpdatingEnabled==false) return;
        
        if(this.selectedHour==null || this.selectedMinute==null){
            this.selectedtime = null;
        }else{
            let h = this.selectedHour.no; 
            let m = this.selectedMinute.no; 
            this.selectedtime = `${h.toString().padStart(2,'0')}:${m.toString().padStart(2,'0')}`
        }
    }

    public set selectedtime(v: string) { 
        this._selectedtime = v; 
        if(this.selectedtime!=null){
            this.disableUpdating()
            let [h,m]=this.selectedtime.split(':').map(x=>parseInt(x));
            this.selectedHour = this.hours.filter(x=>x.no==h)[0];
            this.selectedMinute = this.minutes.filter(x=>x.no==m)[0];
            this.enableUpdating()
        }
    } public get selectedtime(): string { return this._selectedtime;} private _selectedtime: string;

    enableUpdating() {
        this._isUpdatingEnabled = true;
    }
    disableUpdating() {
        this._isUpdatingEnabled = false;
    }

}
export class TimePart extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    
    public set no(v: number) { this._no = v; } public get no(): number { return this._no;} private _no: number;
}